<dgx-components-grid-section
  [themeFlush]="true"
  [themeSpacing]="'none'"
  class="mb-5 mt-6 custom-background"
  [ngClass]="environment.brandKey"
>
  <dgx-components-grid-container>
    <dgx-components-grid-row>
      <dgx-components-grid-column [xs]="12">
        <div *ngIf="environment.brandKey !== 'scottish'" class="divider">
          <hr />
          <p>Or</p>
          <hr />
        </div>
        <div *ngIf="environment.brandKey === 'scottish'" class="py-5"></div>
      </dgx-components-grid-column>

      <dgx-components-grid-column
        [xs]="0"
        [sm]="1"
        [lg]="2"
      ></dgx-components-grid-column>
      <dgx-components-grid-column [xs]="12" [sm]="10" [lg]="8">
        <h2>{{ applianceCategoriesTitle$ | async }}</h2>
        <div
          *ngIf="applianceCategories$ | async as categories"
          class="radio-container"
          data-testid="appliance-type-tiles"
        >
          <ng-container *ngFor="let category of categories">
            <a
              (click)="categoryClick.emit([category.value, category.label])"
              class="radio-icon-button"
              ><dgx-components-icon
                [icon]="category.icon"
                [size]="'xl'"
                class="radio-icon-button__icon"
                [ngClass]="{
                  'rotated-icon': category.label === 'Dishwashers',
                }"
              /><span>{{ category.label }}</span></a
            >
          </ng-container>
        </div>
      </dgx-components-grid-column>
      <dgx-components-grid-column
        [xs]="0"
        [sm]="1"
        [lg]="2"
      ></dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</dgx-components-grid-section>
<div *ngIf="popularVideosBlock$ | async as vm">
  <dgx-components-grid-section
    class="custom-background add-margin"
    [ngClass]="environment.brandKey + '-bottom'"
  >
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column
          [xs]="0"
          [sm]="1"
          [lg]="2"
        ></dgx-components-grid-column>
        <dgx-components-grid-column [xs]="12" [sm]="10" [lg]="8">
          <div *ngIf="vm.popularVideos.length" data-testid="popular-videos">
            <dgx-components-video-list-block
              [autoPlay]="false"
              [body]="vm.popularVideosBody"
              [hideControlPanel]="true"
              [hideFullScreen]="true"
              [title]="vm.popularVideosTitle"
              [videos]="vm.popularVideos"
              [navLink]="vm.viewAllVideosLink"
            />
          </div>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</div>
